<template>
  <v-container class="pa-0 ma-0">
    <v-form ref="notificationForm" :value="notificationFormValue">
      <v-container class="component_main pa-0 ma-0">
        <v-row>
          <v-col>
            <h1>{{formData.id?'Editar notificação':'Nova notificação'}}</h1>
            <p>Envie mensagens para os prestadores e usuários do sistema.</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <label>Prestadores</label>
            <GruposPrestadoresSelect :selecionados="formData.prestador" :isNew="isNew" :selectPrestadores="(dataSelection)=> updatePrestadores(dataSelection)"/>
          </v-col>
          <v-col cols="8" md="4" sm="12">
            <label>Módulo</label>
            <v-select
              v-model="formData.modulo"
              :items="modules"
              :rules="required"
              placeholder="Sobre o qual a notificação se refere"
              item-value="value"
              item-text="label"
              outlined
              dense
              @change="loadPerfis"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8" md="4" sm="12">
            <label>Nome da notificação</label>
            <v-text-field
              v-model="formData.nome"
              :rules="required"
              placeholder="Assunto da Mensagem"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="8" sm="12" md="4">
            <label>Perfis de Acesso</label>
            <v-autocomplete
              v-model="formData.permissao"
              :items="perfis_acesso"
              :menu-props="{ maxHeight: '400' }"
              :rules="required"
              :disabled="disableProfiles"
              placeholder="Selecione um ou mais perfis"
              multiple
              chips
              outlined
              dense
              item-value="value"
              item-text="label"
              :search-input.sync="searchInput"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="togglePerfis">
                  <v-list-item-content>
                    <v-list-item-title>Todos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected.value"
                  close
                  small
                  @click:close="removePerfil(data.item.value)"
                  label
                >{{ data.item.label }}</v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item
                    @click="toggleAutocomplete(data.item, 'permissao')"
                    :class="
                      formData.permissao.includes(data.item.value)
                        ? 'primary--text v-list-item--active'
                        : ''"
                  >
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.label }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8" md="4" sm="12">
            <label>Data de publicação</label>
            <v-menu
              ref="dataPublicacaoBool"
              v-model="dataPublicacaoBool"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataPublicacao"
                  placeholder="Data em que estará disponível"
                  format="DD/MM/YYYY"
                  v-mask="'##/##/####'"
                  dense
                  outlined
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  :rules="[formRules.requiredField, formRules.typeDateFormated]"
                  v-on="on"
                  @blur="data_publicacao = parseDate(dataPublicacao)"
                ></v-text-field>
              </template>
              <v-date-picker color="primary" 
                v-model="data_publicacao"
                no-title
                @input="dataPublicacaoBool = false"
              ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col cols="8" md="4" sm="12">
            <label>Data de expiração</label>
            <v-menu
              ref="dataExpiracaoBool"
              v-model="dataExpiracaoBool"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataExpiracao"
                  placeholder="Data em que estará disponível"
                  format="DD/MM/YYYY"
                  v-mask="'##/##/####'"
                  dense
                  outlined
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="data_expiracao = parseDate(dataExpiracao)"
                  v-on="on"
                  :rules="[formRules.typeDateFormated]"
                ></v-text-field>
              </template>
              <v-date-picker color="primary" 
                v-model="data_expiracao"
                no-title
                @input="dataExpiracaoBool = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="d-flex align-start">
          <v-col cols="8" md="4" sm="12">
            <v-switch
              style="padding-top: 0 !important; margin-top: 0 !important"
              v-model="formData.prioridade_alta"
              :label="'Notificação de alta importância'"
            ></v-switch>
          </v-col>
          <v-col cols="8" md="4" sm="12">
            <v-switch
              style="padding-top: 0 !important; margin-top: 0 !important"
              v-model="formData.is_active"
              :label="'Notificação vísivel para os usuários'"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="8" md="8" sm="12">
                <label>Mensagem</label>
                <v-textarea
                v-model="formData.mensagem"
                placeholder="Escreva a mensagem"
                outlined
                height="80px"
                dense
                counter
                :rules="textAreaRules"
                ></v-textarea>
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="8" md="8" sm="12" class="d-flex justify-end" style="padding-right: 0">
            <v-btn outlined small height="30px" color="primary" @click="close()">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed small height="30px" color="primary" @click="validate()">Salvar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import GruposPrestadoresSelect from '@/components/common/GruposPrestadoresSelect';
const formDataInicial = {
        id: null,
        nome: null,
        modulo: null,
        mensagem: "",
        is_active: false,
        prioridade_alta: false,
        data_publicacao: null,
        data_expiracao: null,
        prestador: [],
        permissao: []
      }
export default {
  props: {
    selectedItem: String,
    close: Function,
    modules: Array
  },
  components: {
    GruposPrestadoresSelect
  },
  data() {
    return {
      formData: {
        id: null,
        nome: null,
        modulo: null,
        mensagem: "",
        is_active: false,
        prioridade_alta: false,
        data_publicacao: null,
        data_expiracao: null,
        prestador: [],
        permissao: []
      },
      isNew: true,
      textAreaRules: [
        (v) => !!v || "Por favor preencha o campo",
        (v) => (!!v && v.length <= 400) || "O limite de caracters para este campo é de 400",
      ],
      notificationFormValue: true,
      required: [(v) => !!v || "Por favor preencha o campo."],
      requestAnswer: "",
      date: new Date().toISOString().substr(0, 10),
      dataPublicacao: null,
      data_publicacao: null,
      dataPublicacaoBool: false,
      dataExpiracao: null,
      data_expiracao: null,
      dataExpiracaoBool: false,
      disableProfiles: true,
      perfis_acesso: [],
      PrestadoresNorm: [],
      searchInput: null
    };
  },
  mounted(){
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    ...mapState({
      formRules: state => state.formRules,
      grupoEconomicoList: state => state.permissions.grupoEconomicoList
    }),
    ...mapGetters({
      getPermissoesModulo: "permissions/getPermissoesModulo"
    }),
    selectAllPrestadores() {
      return this.formData.prestador.length === this.PrestadoresNorm.length;
    },
    selectAllPerfis() {
      return this.formData.permissao.length === this.perfis_acesso.length;
    },
    selectSomePerfis() {
      return this.formData.permissao.length > 0 && !this.selectAllPerfis;
    },
  },
  watch: {
    selectedItem:{
      deep: true,
      handler(val){
        this.dataExpiracao = null
        this.dataPublicacao = null
        this.$refs.notificationForm.reset()
        this.$nextTick(()=>{
        let item = JSON.parse(val) 
        item.data_expiracao = item.data_expiracao? item.data_expiracao.split('T')[0]: null
        item.data_publicacao = item.data_publicacao? item.data_publicacao.split('T')[0]: null
        this.dataExpiracao = this.formatDate(item.data_expiracao)
        this.dataPublicacao = this.formatDate(item.data_publicacao)
        this.formData = (item == {})? {...formDataInicial} : item
        this.isNew = item == {}
        if(item.modulo) {
          this.loadPerfis(item.modulo, item.permissao)
        }
        this.$nextTick(()=>{
          this.formData.permissao = item.permissao
        })
        })
      }
    },
    dataPublicacao(){
      this.formData.data_publicacao = this.parseDate(this.dataPublicacao)
    },
    data_publicacao(){
        this.dataPublicacao = this.formatDate(this.data_publicacao)
        this.formData.data_publicacao = this.data_publicacao
    },
    dataExpiracao(){
      this.formData.data_expiracao = this.parseDate(this.dataExpiracao)
    },
    data_expiracao(){
        this.dataExpiracao = this.formatDate(this.data_expiracao)
        this.formData.data_expiracao = this.data_expiracao
    },
    grupoEconomicoList: {
      deep: true,
      handler(val){
        
    let PrestadoresNormAux = new Array();
      val.forEach(function(gpe) {
      let cliente = {}
      cliente.nome = gpe.grupo_ds
      cliente.id = 'g_'+gpe.grupo_id
      cliente.is_header = true;
      PrestadoresNormAux.push({divider: true});
      PrestadoresNormAux.push(cliente);
      PrestadoresNormAux.push({divider: true});
      gpe.prestador.forEach(function(prestador){
        cliente = new Object();
        cliente.nome = prestador.prest_nome;
        cliente.id = prestador.id;
        cliente.grupo_id = 'g_'+gpe.grupo_id;
        cliente.is_header = false;
        PrestadoresNormAux.push(cliente);
      });
    });
    this.PrestadoresNorm = PrestadoresNormAux;
      }
    },
  },

  methods: {
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },
    parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    formatGrupoPrestadoresList(grupoEconomicoList){
        
    let PrestadoresNormAux = new Array();
      grupoEconomicoList.forEach(function(gpe) {
      let cliente = {}
      cliente.nome = gpe.grupo_ds
      cliente.id = 'g_'+gpe.grupo_id
      cliente.is_header = true;
      PrestadoresNormAux.push({divider: true});
      PrestadoresNormAux.push(cliente);
      PrestadoresNormAux.push({divider: true});
      gpe.prestador.forEach(function(prestador){
        cliente = new Object();
        cliente.nome = prestador.prest_nome;
        cliente.id = prestador.id;
        cliente.grupo_id = 'g_'+gpe.grupo_id;
        cliente.is_header = false;
        PrestadoresNormAux.push(cliente);
      });
    });
    this.PrestadoresNorm = PrestadoresNormAux;
    },
     toggleAutocomplete(item, campo) {
      this.searchInput = null
      let index = this.formData[campo].indexOf(item.value);
      //  index > -1  está excluindo o item
      if (index > -1) {
        this.formData[campo].splice(index, 1);
      } else {
        //  index < 0  está adicionando o item
        this.formData[campo].push(item.value);
      }
      this.$nextTick();
      return;
    },
    updatePrestadores(val) {
      this.formData.prestador = val.filter(el => !!el)
    },
    validate() {
      if (!this.$refs.notificationForm.validate()) {
        return
      }
      let paramModal;

        paramModal = {
          type: "success",
          title: "Sucesso",
          message: "Você poderá editar novamente quando necessário",
          callback: () => this.close(this.formData),
          btConfirm: { name: "Salvar", show: true },
          btCancel: { name: "Cancelar", show: true },
        }

      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    removePerfil(item) {
      const index = this.formData.permissao.indexOf(item);
      if (index >= 0) this.formData.permissao.splice(index, 1);
    },
    togglePerfis() {
      this.searchInput = null
      this.$nextTick(() => {
        if (this.selectAllPerfis) {
          this.formData.permissao = [];
        } else {
          this.formData.permissao = this.perfis_acesso.map(el=> el.value);
        }
      });
    },
    loadPerfis(modulo, permissao){
      this.formData.permissao = []
      this.perfis_acesso = this.getPermissoesModulo(modulo);
      this.disableProfiles = false;
      this.formData.permissao = permissao? permissao : []
    }
  },
};
</script>